let galleryArrowsShowHideTimeout;

function galleryArrowsShowHide () {

  let imageContainer = document.getElementsByClassName('store-product-images')[0];

  if ( this.className.includes('previous') ) {
    imageContainer.scroll(imageContainer.scrollLeft - imageContainer.offsetWidth, 0 );
  } else if ( this.className.includes('next') ) {
    imageContainer.scroll(imageContainer.scrollLeft + imageContainer.offsetWidth, 0 );
  } else {

  }


  if ( imageContainer.scrollLeft < imageContainer.offsetWidth / 2 ) {
    document.getElementsByClassName('store-product-images-previous')[0].style.opacity = '0';
    document.getElementsByClassName('store-product-images-next')[0].style.opacity = '1';
  } else if ( imageContainer.scrollLeft + imageContainer.offsetWidth > imageContainer.scrollWidth - imageContainer.offsetWidth / 2 ) {
    document.getElementsByClassName('store-product-images-previous')[0].style.opacity = '1';
    document.getElementsByClassName('store-product-images-next')[0].style.opacity = '0';
  } else {
    document.getElementsByClassName('store-product-images-previous')[0].style.opacity = '1';
    document.getElementsByClassName('store-product-images-next')[0].style.opacity = '1';
  }

}


document.getElementsByClassName('store-product-images')[0].addEventListener('scroll', galleryArrowsShowHide);

if ( typeof document.getElementsByClassName('store-product-images-previous')[0] != 'undefined' ) {
  document.getElementsByClassName('store-product-images-previous')[0].addEventListener('click', galleryArrowsShowHide);
}

if ( typeof document.getElementsByClassName('store-product-images-next')[0] != 'undefined' ) {
  document.getElementsByClassName('store-product-images-next')[0].addEventListener('click', galleryArrowsShowHide);
}

if (typeof document.getElementsByClassName('store-product-form-numberofItems-minus')[0] != 'undefined') {
  document.getElementsByClassName('store-product-form-numberofItems-minus')[0].addEventListener( 'click', function () { document.getElementsByClassName('store-product-form-numberofItems-input')[0].value != document.getElementsByClassName('store-product-form-numberofItems-input')[0].min ? document.getElementsByClassName('store-product-form-numberofItems-input')[0].value-- : document.getElementsByClassName('store-product-form-numberofItems-input')[0].value });
}

if (typeof document.getElementsByClassName('store-product-form-numberofItems-plus')[0] != 'undefined') {
  document.getElementsByClassName('store-product-form-numberofItems-plus')[0].addEventListener( 'click', function () { document.getElementsByClassName('store-product-form-numberofItems-input')[0].value != document.getElementsByClassName('store-product-form-numberofItems-input')[0].max ? document.getElementsByClassName('store-product-form-numberofItems-input')[0].value++ : document.getElementsByClassName('store-product-form-numberofItems-input')[0].value });
}

